import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@mode/capra';
import { Schedule, ScheduleTime } from '@mode/shared/schedules/contract';
import { CadenceSelectorComponent } from '../cadence-selector/cadence-selector.component';
import { MinuteScheduleConfigComponent } from '../minute-schedule-config/minute-schedule-config.component';
import { MonthlyScheduleConfigComponent } from '../monthly-schedule-config/monthly-schedule-config.component';
import { TimeWithTimeZoneSelectorComponent } from '../time-with-time-zone-selector/time-with-time-zone-selector.component';
import { WeeklyScheduleConfigComponent } from '../weekly-schedule-config/weekly-schedule-config.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    CadenceSelectorComponent,
    MinuteScheduleConfigComponent,
    WeeklyScheduleConfigComponent,
    MonthlyScheduleConfigComponent,
    TimeWithTimeZoneSelectorComponent,
  ],
  selector: 'mode-cadence-config',
  templateUrl: './cadence-config.component.html',
  styleUrls: ['./cadence-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadenceConfigComponent {
  @Input() schedule: Schedule = {
    hour: 0,
    minute: 0,
    timeZone: 'UTC',
    dayOfMonth: '1st',
    dayOfTheWeek: 'Monday',
    frequency: 'monthly',
  };
  @Output() dayOfMonthChanged = new EventEmitter<number>();
  @Output() dayOfWeekChanged = new EventEmitter<number>();
  @Output() frequencyChange = new EventEmitter<string>();
  @Output() startTimeChanged = new EventEmitter<number>();
  @Output() timeChanged = new EventEmitter<ScheduleTime>();
}
